/* Portal do cliente, lado do painel: gerar, ler e revogar o link.

   Quem cria o codigo e o banco, na funcao portal_gerar, que confere se a
   equipe enxerga o caso e se existe data de nascimento cadastrada. Sem a
   data nao ha como conferir quem abriu o link, entao nem gera.

   A tabela portal_links so e alcancavel por quem esta logado, pela policy
   da migracao 007. O cliente nunca fala com ela: as funcoes do portal e
   que leem por dentro. */

import { sb } from "../supabase.js";
import { ADVOGADO } from "../escritorio.js";
import { MARCA, NOME_PORTAL } from "../marca.js";

export async function gerarLink(casoId){
  const { data, error } = await sb.rpc("portal_gerar", { p_caso: casoId });
  if (error) throw error;
  return data || {};
}

/* O link ainda valido do caso, se houver. */
export async function linkVivo(casoId){
  const { data, error } = await sb
    .from("portal_links")
    .select("codigo,expira_em,aberto_em,envios,tentativas,bloqueado_ate")
    .eq("caso_id", casoId)
    .gt("expira_em", new Date().toISOString())
    .order("criado_em", { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data;
}

/* Revogar e vencer na hora. A linha fica, para o historico continuar lá. */
export async function revogarLink(codigo){
  const { error } = await sb.from("portal_links")
    .update({ expira_em: new Date().toISOString() })
    .eq("codigo", codigo);
  if (error) throw error;
}

/* O link do cliente aponta para o dominio do portal, e nao para o endereco
   onde o painel esta aberto: o captador trabalha em parceiros.axijud.com e o
   cliente precisa receber beneficios.axijud.com. Em desenvolvimento fica o
   proprio endereco, senao nao da para testar o portal na maquina. */
const naMaquina = location.hostname === "localhost"
               || location.hostname.endsWith(".local")
               || /^[0-9.]+$/.test(location.hostname);

export const enderecoPortal = codigo =>
  `${naMaquina ? location.origin : MARCA.dominioPortal}/c/${codigo}`;

/* Mensagem pronta para colar no WhatsApp. Primeiro nome só, e sem jargão.

   Ela diz o nome do escritório, e não só o do sistema: o cliente conhece o
   advogado, não conhece o app. Mensagem sem remetente, com link, pedindo data
   de nascimento, é o formato exato de um golpe. */
export function mensagemPortal(cliente, codigo){
  const primeiro = String(cliente || "").trim().split(/\s+/)[0] || "";
  return `Olá ${primeiro}. Aqui é a ${NOME_PORTAL}, do escritório `
       + `${ADVOGADO.nome}, ${ADVOGADO.oab}.\n\n`
       + `Para dar andamento no seu benefício, faltam alguns documentos. `
       + `Abra este link no celular e tire as fotos:\n${enderecoPortal(codigo)}\n\n`
       + `O link vale por 7 dias e vai pedir a sua data de nascimento para `
       + `confirmar que é você.`;
}
